interface ToastProps {
  message: string;
}

/** README §Screens 4: 画面下中央、2.6秒で自動的に消える（親がsetTimeoutで管理）。 */
export function Toast({ message }: ToastProps) {
  if (!message) return null;
  return (
    <div className="mk-toast" role="status">
      {message}
    </div>
  );
}
